<template>
    <apexchart :type="chartType" :options="chartOptions" :series="chartSeries"></apexchart>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        width: {
            type: String,
            default: '500'
        },
        chartType: {
            type: String,
            default: ''
        },
        chartOptions: {
            type: Object,
            default: {}
        },
        chartSeries: {
            type: Array,
            default: []
        }
    },
    
    data() {
        return {
            // chartOptions: {
            //     chart: {
            //         id: 'basic-bar',
            //         type: 'bar',
            //         stacked: true,
            //     },
            //     xaxis: {
            //         categories: ['Bjoern Priske', 'Steve Taylor'],
            //     },
            //     plotOptions: {
            //         bar: {
            //             horizontal: true,
            //         }
            //     }
            // },
            // series: [
            //     {
            //         name: 'Req',
            //         data: [50, 40]
            //     }, {
            //         name: 'Quot',
            //         data: [30, 10]
            //     }, {
            //         name: 'SO',
            //         data: [20, 10]
            //     }
            // ]
        }
    }
}
</script>

<style>

</style>